<template>
    <div class="modal fade" :id="id">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <button @click="closeModal('#' + id)" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-sm-2 mx-50 pb-5">
                    <slot name="header"></slot>
                    <div v-if="error" class="alert alert-danger" role="alert">
                        <div class="alert-body d-flex align-items-center">
                            <vue-feather type="info" size="14" style="overflow: visible;" class="mr-50 align-middle top-0" />
                            <span v-html="message"></span>
                        </div>
                    </div>
                    <div class="row gy-1 gx-2 mt-75">
                        <div class="col-md-12">
                            <label class="form-label" for="payment-modal-holder">
                                {{ localizationStore.translate("card.modal.input.card.name.label") }}
                            </label>
                            <input type="text" v-model="cardHolderName" id="payment-modal-holder" class="form-control" :placeholder="localizationStore.translate('card.modal.input.card.name.placeholder')" />
                        </div>

                        <div class="col-6">
                            <label class="form-label" for="payment-modal-holder-number">
                                {{ localizationStore.translate("card.modal.input.card.number.label") }}
                            </label>
                            <span id="payment-modal-holder-number" class="form-control stripe-element-container" :class="{ 'is-invalid': cardNumberError }">
                                <!-- Stripe Card Element -->
                            </span>
                            <div v-if="cardNumberError != false" class="invalid-feedback">{{ cardNumberError }}</div>
                        </div>

                        <div class="col-6 col-md-3">
                            <label class="form-label" for="payment-modal-expiry-date">
                                {{ localizationStore.translate("card.modal.input.exp.date.label") }}
                            </label>
                            <span id="payment-modal-expiry-date" class="form-control stripe-element-container" :class="{ 'is-invalid': cardExpiryError }">
                            </span>
                            <div v-if="cardExpiryError != false" class="invalid-feedback">{{ cardExpiryError }}</div>
                        </div>

                        <div class="col-6 col-md-3">
                            <label class="form-label" for="payment-modal-cvc">
                                {{ localizationStore.translate("card.modal.input.cvc.label") }}
                            </label>
                            <span id="payment-modal-cvc" class="form-control stripe-element-container" :class="{ 'is-invalid': cvcError }">
                            </span>
                            <div v-if="cvcError != false" class="invalid-feedback">{{ cvcError }}</div>
                        </div>

                        <slot name="form-attributes"></slot>
                    </div>
                    <div class="form-group mt-1">
                        <div class="custom-control custom-checkbox">
                            <input
                                class="custom-control-input"
                                type="checkbox"
                                :id="`${id}term_and_agreement`"
                                name="term_and_agreement"
                                v-model="termAndAgreement"
                            />
                            <label class="custom-control-label" :for="`${id}term_and_agreement`">
                                I agree to
                            </label>
                            <a href="#" data-target="#TermConditionModel" data-toggle="modal"> privacy policy & terms</a>
                        </div>
                    </div>
                    <slot
                        name="footer"
                        :subscribe="subscribe"
                        :pay="pay"
                        :topUp="topUp"
                        :purchaseCourse="purchaseCourse"
                        :addCard="addCard"
                        :subscribeCourse="subscribeCourse"
                        :SubscribeCourseOneTime="SubscribeCourseOneTime"
                    ></slot>
                </div>
            </div>
        </div>
    </div>
    <TermConditionComponent/>
</template>
<script>
    import { loadStripe } from '@stripe/stripe-js'
    import { defineComponent, ref, onBeforeMount } from 'vue'
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { usePlanStore } from '../../stores/PlanStore.js'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useSpinStore } from '../../stores/SpinStore.js'
    import  TermConditionComponent from '../models/TermConditionComponent'
    import { closeModal, openModal, hideModal } from '../../utilities/_helpers'
    import { useEducationStore } from '../../stores/EducationStore.js'
    export default defineComponent({
        name: 'PaymentModal',
        props: {
            id: String,
            planSlug: String,
            selectedPlan: String,
            coupon: Number,
            intent: String,
            chargeType: String,
            topUpType: String,
            courseName: String,
            subscriptionType:Number
        },
        components: {
            TermConditionComponent
        },
        setup(props) {
            return {
                stripe: ref(),
                cardNumber: ref(),
                cardNumberError: ref(false),
                cardHolderName: ref(),
                cardExpiry: ref(),
                cardExpiryError: ref(false),
                cvc: ref(),
                cvcError: ref(false),
                localizationStore: useLocalizationStore(),
                planStore: usePlanStore(),
                userStore: useUserStore(),
                spinStore: useSpinStore(),
                message: ref(),
                error: ref(false),
                termAndAgreement:ref(false),
                days: process.env.MIX_TRIAL_DAYS,
                closeModal: closeModal,
                token: ref(null),
                educationStore:useEducationStore(),
                subscriptionType:!_.isNull(props.subscriptionType) ||  !_.isUndefined(props.subscriptionType) ? props.subscriptionType : 0
            }
        },
        async mounted() {
            this.stripe = await loadStripe(process.env.MIX_STRIPE_KEY);
            var $this = this;
            const elements = this.stripe.elements();
            const style = {
                base: {
                    'fontSize': '16px',
                    'color': '#6e6b7b',
                    'fontFamily': 'apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif',
                    '::placeholder': {
                        color: '#b9b9c3',
                    },
                }
            };

            // Card number
            this.cardNumber = elements.create('cardNumber', {
                'placeholder': '4242 4242 4242 4242',
                'style': style
            });
            this.cardNumber.mount(`#${this.id} #payment-modal-holder-number`);
            this.cardNumber.on("change", function (event) {
                $this.resetErrors();
                if (event.error) {
                    $this.handleError(event.error);
                }
            });
            this.cardNumber.on("blur", function (event) {
                $this.resetErrors();
                if (event.error) {
                    $this.handleError(event.error);
                }
            });
            // Card expiry
            this.cardExpiry = elements.create('cardExpiry', {
                'placeholder': 'MM/YY',
                'style': style
            });
            this.cardExpiry.mount(`#${this.id} #payment-modal-expiry-date`);
            this.cardExpiry.on("change", function (event) {
                $this.resetErrors();
                if (event.error) {
                    $this.handleError(event.error);
                }
            });
            this.cardExpiry.on("blur", function (event) {
                $this.resetErrors();
                if (event.error) {
                    $this.handleError(event.error);
                }
            });
            // CVC
            this.cvc = elements.create('cardCvc', {
                'placeholder': '321',
                'style': style
            });
            this.cvc.mount(`#${this.id} #payment-modal-cvc`);
            this.cvc.on("change", function (event) {
                $this.resetErrors();
                if (event.error) {
                    $this.handleError(event.error);
                }
            });
            this.cvc.on("blur", function (event) {
                $this.resetErrors();
                if (event.error) {
                    $this.handleError(event.error);
                }
            });

            $('#trial-payment-modal').on('hide.bs.modal', function () {
                localStorage.setItem('enableCardPopup', false);
            })
        },
        created() {
        },
        methods: {
            subscribe: async function () {
                if (!this.termAndAgreement) {
                    this.planStore.paymentBtnKey++;
                    return toastr.error('Please accept the privacy policy & terms.','Error!');
                }
                if (_.isNull(this.token)) {
                    const { paymentMethod, error } = await this.stripe.createPaymentMethod(
                        'card', this.cardNumber, {
                            billing_details: {
                                name: this.cardHolderName,
                                email: this.userStore.user.email,
                            }
                        }
                    );
                    if (error) {
                        this.handleError(error);
                        return;
                    } else {
                        const { setupIntent, error } = await this.stripe.confirmCardSetup(
                            this.intent,
                            {
                                payment_method: paymentMethod.id
                            }
                        );
                        if (error) {
                            this.handleError(error);
                            return;
                        }
                        else {
                            this.token = setupIntent.payment_method;
                        }
                    }
                }
                const route = this.$router.resolve(
                    {
                        name: 'billing-subscriptions-store',
                    }
                );
                const $this = this;
                axios.post(route.href, {
                    token: this.token,
                    plan: this.planSlug,
                    coupon: this.coupon,
                    term_and_agreement: this.termAndAgreement,
                    referral: Rewardful?.referral
                })
                .then(function (response) {
                    if(response.data.error == true) {
                        $this.planStore.paymentBtnKey++;
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    setTimeout(() => {
                        location.reload();
                    }, 3000)
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            pay: async function () {
                if (!this.termAndAgreement) {
                    this.planStore.paymentBtnKey++;
                    return toastr.error('Please accept the privacy policy & terms.','Error!');
                }
                const { paymentMethod, error } = await this.stripe.createPaymentMethod(
                    'card', this.cardNumber, {
                        billing_details: {
                            name: this.cardHolderName,
                            email: this.userStore.user.email
                        }
                    }
                );
                if (error) {
                    this.handleError(error);
                    return;
                } else {
                    const $this = this;
                    const route = this.$router.resolve(
                        {
                            name: 'purchase-attach-card'
                        }
                    );
                    axios.post(route.href, {
                        paymentMethodId: paymentMethod.id,
                        plan: this.selectedPlan,
                        term_and_agreement: this.termAndAgreement,
                        referral: Rewardful?.referral
                    })
                    .then(function (response) {
                        $this.planStore.paymentBtnKey++;
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        $this.resetForm();
                        hideModal(`#${$this.id}`);
                        toastr.success(response.data.message, 'Success!');
                        setTimeout(() => {window.location.reload();}, 3000)
                    })
                    .catch(function (error) {
                        $this.planStore.paymentBtnKey++;
                        console.log(error);
                    });
                }
            },
            topUp: async function () {
                if (!this.termAndAgreement) {
                    this.planStore.paymentBtnKey++;
                    return toastr.error('Please accept the privacy policy & terms.','Error!');
                }
                let email = this.userStore.user.email;
                if (this.userStore.user.isClient == true) {
                    email = this.userStore.user.owner.email;
                }
                const { paymentMethod, error } = await this.stripe.createPaymentMethod(
                    'card', this.cardNumber, {
                        billing_details: {
                            name: this.cardHolderName,
                            email: email
                        }
                    }
                );

                if (error) {
                    this.handleError(error);
                    return;
                } else {
                    var $this = this;
                    const route = this.$router.resolve(
                        {
                            name: 'purchase-top-up',
                            params: {
                                client: $this.$route.params.client,
                                team: $this.$route.params.team
                            }
                        }
                    );
                    axios.post(route.href, {
                        paymentMethodId: paymentMethod.id,
                        top_up_type: this.topUpType,
                        team_id: this.$route.params.team
                    })
                    .then(function (response) {
                        $this.planStore.paymentBtnKey++;
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        $this.userStore.user.balance = response.data.data.balance;
                        $this.resetForm();
                        hideModal(`#${$this.id}`);
                        toastr.success(response.data.message, 'Success!');
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },
            addCard: async function () {
                if (!this.termAndAgreement) {
                    this.planStore.paymentBtnKey++;
                    return toastr.error('Please accept the privacy policy & terms.','Error!');
                }
                let email = this.userStore.user.email;
                if (this.userStore.user.isClient == true) {
                    email = this.userStore.user.owner.email;
                }
                const { paymentMethod, error } = await this.stripe.createPaymentMethod(
                    'card', this.cardNumber, {
                        billing_details: {
                            name: this.cardHolderName,
                            email: email
                        }
                    }
                );

                if (error) {
                    this.handleError(error);
                    return;
                } else {
                    var $this = this;
                    const route = this.$router.resolve(
                        {
                            name: 'purchase-add-card',
                        }
                    );
                    axios.post(route.href, {
                        paymentMethodId: paymentMethod.id,
                        term_and_agreement: this.termAndAgreement,
                    })
                    .then(function (response) {
                        $this.planStore.paymentBtnKey++;
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        $this.resetForm();
                        hideModal(`#${$this.id}`);
                        $this.userStore.profile.payment_methods.push(response.data.data);
                        toastr.success(response.data.message, 'Success!');
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },
            purchaseCourse: async function(){
                if (!this.termAndAgreement) {
                    this.planStore.paymentBtnKey++;
                    return toastr.error('Please accept the privacy policy & terms.','Error!');
                }
                let email = this.userStore.user.email;
                if (this.userStore.user.isClient == true) {
                    email = this.userStore.user.owner.email;
                }
                const { paymentMethod, error } = await this.stripe.createPaymentMethod(
                    'card', this.cardNumber, {
                        billing_details: {
                            name: this.cardHolderName,
                            email: email
                        }
                    }
                );

                if (error) {
                    this.handleError(error);
                    return;
                } else {
                    var $this = this;
                    const route = this.$router.resolve(
                        {
                            name: 'purchase-course',
                            course:this.courseName
                        }
                    );
                    axios.post(route.href, {
                        paymentMethodId: paymentMethod.id,
                        course_name: this.courseName,
                        term_and_agreement: this.termAndAgreement,
                        purchase_type:this.planStore.purchase_type
                    })
                    .then(function (response) {
                        $this.planStore.paymentBtnKey++;
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        $this.userStore.course = response.data.data
                        $this.educationStore.content.hasPurchased = true
                        $this.resetForm();
                        hideModal(`#${$this.id}`);
                        toastr.success(response.data.message, 'Success!');
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },
            SubscribeCourseOneTime: async function(){
                if (!this.termAndAgreement) {
                    this.planStore.uniqueKeyBtn++;
                    return toastr.error('Please accept the privacy policy & terms.','Error!');
                }
                let email = this.userStore.user.email;
                if (this.userStore.user.isClient == true) {
                    email = this.userStore.user.owner.email;
                }
                const { paymentMethod, error } = await this.stripe.createPaymentMethod(
                    'card', this.cardNumber, {
                        billing_details: {
                            name: this.cardHolderName,
                            email: email
                        }
                    }
                );

                if (error) {
                    this.handleError(error);
                    return;
                } else {
                    var $this = this;
                    const route = this.$router.resolve(
                        {
                            name: 'lifetime-course-subscription',
                        }
                    );
                    axios.post(route.href, {
                        paymentMethodId: paymentMethod.id,
                        plan: this.planSlug,
                        term_and_agreement: this.termAndAgreement,
                    })
                    .then(function (response) {
                        $this.planStore.uniqueKeyBtn++;
                        if(response.data.error == true) {
                            toastr.error(response.data.message, 'Error!');
                            return;
                        }
                        $this.userStore.course = response.data.data
                        window.location.reload()
                        $this.resetForm();
                        hideModal(`#${$this.id}`);
                        toastr.success(response.data.message, 'Success!');
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
                }
            },
            handleError: function (error) {
                this.planStore.paymentBtnKey++;
                switch (error.code) {
                    case "incomplete_number":
                        this.cardNumberError = error.message;
                        break;
                    case "invalid_number":
                        this.cardNumberError = error.message;
                        break;
                    case "incorrect_number":
                        this.cardNumberError = error.message;
                        break;
                    case "invalid_expiry_year_past":
                        this.cardExpiryError = error.message;
                        break;
                    case "invalid_expiry_month_past":
                        this.cardExpiryError = error.message;
                        break;
                    case "incomplete_expiry":
                        this.cardExpiryError = error.message;
                        break;
                    case "incomplete_cvc":
                        this.cvcError = error.message;
                        break;
                    case "incorrect_cvc":
                        this.cvcError = error.message;
                        break;
                    default:
                        this.message = error.message;
                        this.error = true;
                }
            },
            subscribeCourse: async function () {
                if (!this.termAndAgreement) {
                    this.planStore.paymentBtnKey++;
                    return toastr.error('Please accept the privacy policy & terms.','Error!');
                }
                if (_.isNull(this.token)) {
                    const { paymentMethod, error } = await this.stripe.createPaymentMethod(
                        'card', this.cardNumber, {
                            billing_details: {
                                name: this.cardHolderName,
                                email: this.userStore.user.email,
                            }
                        }
                    );
                    if (error) {
                        this.handleError(error);
                        return;
                    } else {
                        const { setupIntent, error } = await this.stripe.confirmCardSetup(
                            this.intent,
                            {
                                payment_method: paymentMethod.id
                            }
                        );
                        if (error) {
                            this.handleError(error);
                            return;
                        }
                        else {
                            this.token = setupIntent.payment_method;
                        }
                    }
                }
                const route = this.$router.resolve(
                    {
                        name: 'courses-subscribe',
                    }
                );
                const $this = this;
                let payload = {
                    token: this.token,
                    plan: this.planSlug,
                    coupon: this.coupon,
                    term_and_agreement: this.termAndAgreement,
                }
                axios.post(route.href, payload)
                .then(function (response) {
                    if(response.data.error == true) {
                        $this.planStore.paymentBtnKey++;
                        toastr.error(response.data.message, 'Error!');
                        return;
                    }
                    toastr.success(response.data.message, 'Success!');
                    setTimeout(() => {
                        location.reload();
                    }, 3000)
                })
                .catch(function (error) {
                    console.log(error);
                });
            },
            resetForm: function () {
                this.cardNumber.clear();
                this.cardExpiry.clear();
                this.cvc.clear();
                this.cardHolderName = '';
            },
            resetErrors: function () {
                this.cardNumberError = false;
                this.cardExpiryError = false;
                this.cvcError = false;
                if (this.error == true) {
                    this.error = false;
                }
            }
        }
    });
</script>
